import Nav from '../components/navbar/Navbar';
import QuizPage from '../components/quizPage/QuizPage';

export default function Exam() {
    return (
        <>
            <Nav />
            <QuizPage />
        </>
    );
}
